import { render } from "./CreateShift.vue?vue&type=template&id=1228afae&scoped=true"
import script from "./CreateShift.vue?vue&type=script&lang=js"
export * from "./CreateShift.vue?vue&type=script&lang=js"

import "./CreateShift.vue?vue&type=style&index=0&id=1228afae&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1228afae"]])

export default __exports__